// src/components/Signup.js
import React, { useEffect, useRef, useState } from 'react';
import { Form, Button, Message, Segment, Header, Container } from 'semantic-ui-react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

export default function Signup() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { signup, currentUser, signInWithGoogle } = useAuth();
  const navigate = useNavigate();

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Redirect authenticated user to dashboard
  useEffect(() => {
    if (currentUser) {
      navigate('/dashboard');
    }
  }, [currentUser, navigate]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError('Passwords do not match');
    }

    try {
      setError('');
      setLoading(true);
      await signup(emailRef.current.value, passwordRef.current.value);
      navigate('/dashboard');
    } catch (err) {
      console.error(err);
      // Customize error messages based on error codes
      switch (err.code) {
        case 'auth/email-already-in-use':
          setError('Email is already in use');
          break;
        case 'auth/invalid-email':
          setError('Invalid email address');
          break;
        case 'auth/weak-password':
          setError('Password should be at least 6 characters');
          break;
        default:
          setError('Failed to create an account');
      }
    }

    setLoading(false);
  };

  return (
    <Container text>
      <Segment padded style={{ marginTop: '7em' }}>
        <Header as="h2" textAlign="center">
          Sign Up
        </Header>
        <Form onSubmit={handleSubmit} error={!!error}>
          <Form.Field required>
            <label>Email</label>
            <input type="email" ref={emailRef} placeholder="Enter your email" required />
          </Form.Field>
          <Form.Field required>
            <label>Password</label>
            <input type="password" ref={passwordRef} placeholder="Enter your password" required />
          </Form.Field>
          <Form.Field required>
            <label>Confirm Password</label>
            <input
              type="password"
              ref={passwordConfirmRef}
              placeholder="Confirm your password"
              required
            />
          </Form.Field>
          {error && <Message error header="Error" content={error} />}
          <Form.Field >
            <Button primary type="submit" fluid loading={loading} disabled={loading}>
              Sign Up
            </Button>
          </Form.Field>
          <Form.Field >
            <Button color="google plus" onClick={signInWithGoogle} fluid>
              <i className="google icon" />
              Sign Up with Google
            </Button>
          </Form.Field>
        </Form>
        <Message>
          Already have an account? <Link to="/login">Log In</Link>
        </Message>
      </Segment>
    </Container>
  );
}
